<template>
    <div class="mb-10 flex items-center">
        <div class="text-md uppercase mr-4">
            {{ t.filter }}:
        </div>
        <Dropdown v-model="selected" :options="options" optionLabel="label" optionValue="value" :placeholder="t.all" :showClear="true" />
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4 md:gap-8 xl:gap-10" v-if="this.filteredData.length > 0">
        <template v-for="(item, index) in paginatedData()" :key="index">
        <news-item :item="item"></news-item>
        </template>
    </div>
    <div v-else class="my-20">
        <div class="text-2xl text-center font-light">
            {{ t.noResults }}
        </div>
    </div>
    <div class="my-8 xl:my-20">
        <Paginator 
            :rows="limit"
            :totalRecords="this.filteredData.length"            
            :alwaysShow="false"
            :pageLinkSize="this.$store.getters['env/isLarge'] ? 8 : 4"
            template="PrevPageLink PageLinks NextPageLink"
            v-model:first="page"
        >                
        </Paginator>
    </div>
</template>

<script>
import ContentApi from '../../mixins/ContentApi.vue'
import FilterByTag from '../../mixins/FilterByTag.vue'
import Dropdown from 'primevue/dropdown/sfc';
import Paginator from 'primevue/paginator/sfc';

import NewsItem from './NewsItem.vue'

export default {

    props: {
        't': Object,
        'site': Object
    },

    components: {
        NewsItem,
        Dropdown,
        Paginator
    },

    mixins: [ContentApi, FilterByTag],

    data() {
        return {
            data: '',
            filterProperty: 'news_category',
            selected: null,
            url: '/api/collections/news/entries?sort=-date&filter[site]='+this.site.handle,
            page: 0,
            limit: 12
        }
    },

    methods: {
        paginatedData() {
            if (! this.limit) {
                return this.filteredData
            }
            return this.filteredData.slice(this.page, (this.page + this.limit))
        },
    }

};
</script>